// ── API data → ProductCard props ──────────────────────────────────────────────
export function normalizeProduct(item) {
  if (!item) return null;               // ← guard

  const price = item?.price ?? 0;
  const mrp   = item?.mrp   ?? 0;

  return {
    id:            item?.slug || item?._id,
    name:          item?.title,
    craft:         item?.category || item?.brand || null,
    price,
    originalPrice: mrp > price ? mrp : null,
    badge:         item?.discount > 0 ? `${item.discount}% Off` : null,
    image:         item?.thumbnail,
    gallery:       item?.gallery || [],
    slug:          item?.slug,
    video:         item?.video || null,
  };
}